var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#138de8;}.b{stroke:#fdfdfd;stroke-width:2px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-335 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(335 66)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.045,19.976a3.493,3.493,0,0,1-2.33-1.307.7.7,0,0,1,.109-.98.683.683,0,0,1,.968.111,2.115,2.115,0,0,0,1.414.79,2.14,2.14,0,0,0,1.577-.445,1.911,1.911,0,0,0,.356-.347.685.685,0,0,1,.969-.106.7.7,0,0,1,.105.981,3.29,3.29,0,0,1-.6.583,3.492,3.492,0,0,1-2.571.721ZM4.013,15.846A4.9,4.9,0,0,1,.927,14.323,4.06,4.06,0,0,1,0,11.662v-.238A4.1,4.1,0,0,1,.67,9.38l.067-.086a3.858,3.858,0,0,0,.929-1.821l-.015.061,0-.535.012-.6c.009-.262.023-.5.042-.723A5.981,5.981,0,0,1,3.935,1.627,7.13,7.13,0,0,1,8.465,0h.072a7.138,7.138,0,0,1,4.53,1.626A6.022,6.022,0,0,1,15.3,5.685c.017.2.025.379.028.647v.673c0,.11,0,.208,0,.308l.009.2.045.187a3.9,3.9,0,0,0,.726,1.431l.15.177.062.079A4.042,4.042,0,0,1,17,11.459v.4a4.063,4.063,0,0,1-.966,2.5,4.786,4.786,0,0,1-3.047,1.487,41.635,41.635,0,0,1-4.493.244A41.6,41.6,0,0,1,4.013,15.846ZM1.787,10.2h0l-.077.129a2.684,2.684,0,0,0-.313.939l-.017.191v.219a2.657,2.657,0,0,0,.575,1.715,3.493,3.493,0,0,0,2.2,1.066,40.451,40.451,0,0,0,4.342.235,40.537,40.537,0,0,0,4.357-.236,3.434,3.434,0,0,0,2.157-1.031,2.666,2.666,0,0,0,.613-1.774V11.49a2.583,2.583,0,0,0-.435-1.323l.015.025-.138-.162a5.3,5.3,0,0,1-1.013-2l-.065-.276-.013-.093c-.011-.147-.016-.266-.019-.4l0-.9c0-.228-.008-.382-.022-.547A5.31,5.31,0,0,0,8.536,1.395H8.465A5.291,5.291,0,0,0,3.08,5.807c-.011.122-.02.256-.029.422L3.036,6.7l-.007.919-.014.142a5.26,5.26,0,0,1-1.22,2.434h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(347 64)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.5,
    cy: 4.5,
    r: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.45913ddb7de172562e13b170e6fd4999.svg";
export { ForwardRef as ReactComponent };